// extracted by mini-css-extract-plugin
module.exports = {"earnings-card":"earnings-card_earnings-card__2JKZM","subtext":"earnings-card_subtext__1APRR","label":"earnings-card_label__1Sii9"};